import './MainFooter.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { isAuthPage } from 'utils/utils';

import A from 'components/A';
import Logo from 'components/Logo';

export default class MainFooter extends React.Component {
    static propTypes = {
        pathname: PropTypes.string.isRequired
    };

    render() {
        return (
            <footer className="c-main-footer">
                <div className="c-main-footer--inner">
                    {isAuthPage(this.props.pathname) !== true || this.props.pathname === '/' || this.props.pathname === '/create-your-business-account' || this.props.pathname === '/create-your-business-account/form' ? (
                        <Logo
                            noText
                        />
                    ) : null}
                    <div className="c-main-footer__copyright">
                        &copy;{new Date().getFullYear()} The Hunt. All Rights Reserved.
                    </div>
                    <nav className="c-main-footer__nav">
                       <A to="/privacy-policy">Privacy</A>&nbsp;&nbsp;|&nbsp;&nbsp;<A to="/terms">Terms & Conditions</A>&nbsp;&nbsp;|&nbsp;&nbsp;<A href="mailto:jennifer@thehunt.agency?subject=Question about The Hunt Agency">Contact Us</A>
                    </nav>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MainFooter/index.js